import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToServices = () => {
    if (location.pathname === '/') {
      // Already on homepage — scroll immediately
      document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Store scroll intent
      localStorage.setItem('scrollTarget', 'services');
      navigate('/');
    }
  };

  const scrollToPartners = () => {
    if (location.pathname === '/') {
      // Already on homepage — scroll immediately
      document.getElementById('partners')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Store scroll intent
      localStorage.setItem('scrollTarget', 'partners');
      navigate('/');
    }
  };

  return (
    <footer className="bg-black text-white py-16">
      <div className="mx-auto px-10 sm:px-32 lg:px-36">
        <div className="grid md:grid-cols-2 gap-8 mb-12 justify-items-center md:justify-items-stretch">
          <div>
            <Link to="/" className="flex items-center shrink-0 font-serifDisplay">
              <span className="text-customTeal text-[28px]">nv</span>
              <span className="text-white text-[28px]">/global</span>
            </Link>
            <p className="text-white underline text-[13px] font-medium mt-2.5">info@nvglobal.co</p>
          </div>
          
          <div className="md:text-right">
            <nav className="flex flex-col md:flex-row md:items-center md:justify-end md:space-x-8 space-y-4 md:space-y-0 mb-8">
              <a onClick={scrollToServices} className="text-white hover:text-customTeal transition-colors text-sm underline cursor-pointer">Services</a>
              <a href="/team" className="text-white hover:text-customTeal transition-colors text-sm underline">Team</a>
              <a onClick={scrollToPartners} className="text-white hover:text-customTeal transition-colors text-sm underline cursor-pointer">Network Partners</a>
              <a href="/insights" className="text-white hover:text-customTeal transition-colors text-sm underline">Insights</a>
              <a href="/contact" className="text-white hover:text-customTeal transition-colors text-sm underline">Contact</a>
            </nav>
          </div>
        </div>
        
        <div className="pt-8 flex flex-col md:flex-row md:items-end md:justify-between">
          {/* Left: Copyright */}
          <p className="text-white text-[13px] font-bold text-center md:text-left order-2 md:order-1 mt-6 md:mt-0">
            © 2025 NV Global. All Rights Reserved.
          </p>
          {/* Right: Icons + Follow Us */}
          <div className="flex flex-col items-center md:items-end order-1 md:order-2">
            <div className="flex space-x-4 mb-8">
              <a href="https://x.com/NVGlobal1" target="_blank" className="w-[43px] h-[43px] bg-black border-2 border-white rounded-full flex items-center justify-center hover:bg-customTeal transition-colors">
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                  width="28" height="26" viewBox="0 0 450 450"
                  preserveAspectRatio="xMidYMid meet">
                  <g transform="translate(0.000000,980.000000) scale(0.100000,-0.100000)"
                  fill="white" stroke="none">
                  <path d="M899 8933 c5 -10 248 -367 540 -793 518 -757 529 -775 512 -795 -49
                  -54 -998 -1172 -1004 -1182 -6 -10 19 -13 116 -13 l124 0 445 524 c404 476
                  447 523 460 508 8 -9 169 -244 358 -520 189 -277 348 -506 354 -508 6 -2 190
                  -3 409 -2 l398 3 -497 720 c-273 396 -517 750 -541 787 l-45 66 509 599 c280
                  329 512 604 517 611 5 9 -20 12 -116 11 l-123 0 -450 -530 c-247 -291 -450
                  -529 -450 -529 -1 0 -165 238 -365 530 l-365 530 -398 0 c-376 0 -397 -1 -388
                  -17z m686 -161 c13 -9 1673 -2415 1681 -2437 6 -14 -15 -15 -182 -13 l-189 3
                  -832 1215 c-457 668 -832 1221 -832 1228 -1 9 40 12 172 12 94 0 177 -4 182
                  -8z"/>
                  </g>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/nvglobalventures" target="_blank" className="w-[43px] h-[43px] bg-black border-2 border-white rounded-full flex items-center justify-center hover:bg-customTeal transition-colors">
                <svg width="18" height="18" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M6.2862 4.92314H9.76384V6.6686H9.81417C10.2985 5.81797 11.4827 4.92314 13.2486 4.92314C16.9208 4.92314 17.6 7.16051 17.6 10.0711V16H13.9733V10.7443C13.9733 9.49138 13.9466 7.87854 12.0874 7.87854C10.1991 7.87854 9.90965 9.24239 9.90965 10.653V16H6.28617V4.92314H6.2862ZM3.77192 1.84626C3.77192 2.86542 2.9271 3.69252 1.88611 3.69252C0.845115 3.69252 0 2.86542 0 1.84626C0 0.827097 0.845115 0 1.88611 0C2.9271 0 3.77192 0.827097 3.77192 1.84626ZM0 4.92314H3.77192V16H0V4.92314Z" fill="white" />
                </svg>
              </a>
            </div>
            <p className="text-[19.5px] font-bold">Follow Us.</p>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;